import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { makeGetRequest } from "../services/httpHelper";
import ErrorHandler from "../services/ErrorHandler";

const CurrencyContext = createContext();

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState("KES");
  const [rate, setRate] = useState(1); // KES→USD
  const [isLoading,setIsLoading] = useState(false);
  const [serverError,setServerError] = useState(null);

   const loadRate = async()=>{
          setIsLoading(true);
          const res = await makeGetRequest(`fx/kes-usd`);
          if (res && res.errorType) {
              setIsLoading(false);
              const errorMessage = ErrorHandler(res)
              setServerError(errorMessage)
      
          } else {
            console.log('RATE',res.data)
            setRate(res.data.rate);
            
              setIsLoading(false);
              setServerError(null)
              
      
          }
         
      }

  useEffect(() => {
  
    loadRate();
  }, []);

  const convert = (kes) => (currency === "USD" ? (kes / rate).toFixed(2) : kes);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, convert, rate }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
